/**
 * Global variant storage for accessing A/B test variant in loaders/actions
 *
 * Since React Router loaders and actions cannot directly access React Context,
 * we store the variant globally so it can be accessed anywhere.
 *
 * The variant is set by ABTestProvider during initialization and persists
 * via Confidence cookie across page refreshes.
 */

let globalVariant: string = 'baseline'

/**
 * Set the current A/B test variant globally
 * Called by ABTestProvider when variant is resolved
 *
 * Also sets a data-variant attribute on the HTML element for CSS theming
 */
export function setABTestVariantInContext(variant: string): void {
  globalVariant = variant
  // Set data attribute on HTML element for variant-based CSS theming
  document.documentElement.setAttribute('data-variant', variant)
  console.log('✓ Global variant set:', variant)
}

/**
 * Get the current A/B test variant
 * Can be called from anywhere, including React Router actions/loaders
 */
export function getABTestVariantFromContext(): string {
  return globalVariant
}
